import messages from '../locales/messages';
import { FormattedMessage } from 'react-intl';

const contentv2 = {
  introduction: {
    title: <FormattedMessage {...messages.introTitle} />,
    copy: <FormattedMessage {...messages.introCopyV2} />,
    button: <FormattedMessage {...messages.introButton} />,
    imageSrc: 'images/cover.png',
  },
  questions: [
    {
      id: 'q1',
      questionNumber: 1.1,
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q1Title} />,
      imageSrc: 'images/v2-question-1.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q2',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q2',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q2',
        },
      ],
    },
    {
      id: 'q2',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q2Title} />,
      imageSrc: 'images/v2-question-2.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q3',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q3',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q3',
        },
      ],
    },
    {
      id: 'q3',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q3Title} />,
      imageSrc: 'images/v2-question-3.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q4',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q4',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q4',
        },
      ],
    },
    {
      id: 'q4',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q4Title} />,
      imageSrc: 'images/v2-question-4.png',
      popUp: {
        popUpTitle: <FormattedMessage {...messages.q4PopUpTitleV2} />,
        popUpText: <FormattedMessage {...messages.q4PopUpText} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q5',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q5',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q5',
        },
      ],
    },
    {
      id: 'q5',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q5Title} />,
      imageSrc: 'images/v2-question-5.png',
      popUp: {
        popUpTitle: <FormattedMessage {...messages.q5PopUpTitleV2} />,
        popUpText: <FormattedMessage {...messages.q5PopUpText} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q6',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q6',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q6',
        },
      ],
    },
    {
      id: 'q6',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q6Title} />,
      imageSrc: 'images/v2-question-6.png',
      popUp: {
        popUpTitle: <FormattedMessage {...messages.q6PopUpTitleV2} />,
        popUpText: <FormattedMessage {...messages.q6PopUpText} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q7',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q7',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q7',
        },
      ],
    },
    {
      id: 'q7',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q7Title} />,
      imageSrc: 'images/v2-question-7.png',
      popUp: {
        popUpTitle: <FormattedMessage {...messages.q7PopUpTitleV2} />,
        popUpText: <FormattedMessage {...messages.q7PopUpText} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q8',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q8',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q8',
        },
      ],
    },
    {
      id: 'q8',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q8TitleV2} />,
      imageSrc: 'images/v2-question-8.png',
      popUp: {
        popUpTitle: <FormattedMessage {...messages.q8PopUpTitleV2} />,
        popUpText: <FormattedMessage {...messages.q8PopUpText} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q9',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q9',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q9',
        },
      ],
    },
    {
      id: 'q9',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q9Title} />,
      imageSrc: 'images/v2-question-9.png',
      popUp: {
        popUpTitle: <FormattedMessage {...messages.q9PopUpTitleV2} />,
        popUpText: <FormattedMessage {...messages.q9PopUpText} />,
      },
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'q10',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'q10',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'q10',
        },
      ],
    },
    {
      id: 'q10',
      type: 'single-option-media',
      title: <FormattedMessage {...messages.q10Title} />,
      imageSrc: 'images/v2-question-10.png',
      options: [
        {
          optionId: 'yes',
          text: <FormattedMessage {...messages.yesString} />,
          nextStep: 'results',
        },
        {
          optionId: 'no',
          text: <FormattedMessage {...messages.noString} />,
          nextStep: 'results',
        },
        {
          optionId: 'notSure',
          text: <FormattedMessage {...messages.notSureString} />,
          nextStep: 'results',
        },
      ],
    },
  ],
  results: {
    resultsTitleGreen: <FormattedMessage {...messages.resultsTitleGreen} />,
    resultsSubtitleGreen: (
      <FormattedMessage {...messages.resultsSubtitleGreenV2} />
    ),
    resultsTitleYellow: <FormattedMessage {...messages.resultsTitleYellow} />,
    resultsSubtitleYellow: (
      <FormattedMessage {...messages.resultsSubtitleYellowV2} />
    ),
    resultsTitleRed: <FormattedMessage {...messages.resultsTitleRed} />,
    resultsSubtitleRed: <FormattedMessage {...messages.resultsSubtitleRed} />,
    resultsCopy: <FormattedMessage {...messages.resultsCopyV2} />,
    // Deepen your insight
    insightTitle: <FormattedMessage {...messages.insightTitle} />,
    insightCopy: <FormattedMessage {...messages.insightCopy} />,
    insightCta: <FormattedMessage {...messages.insightCta} />,
    // talk to an expert
    whatDoYouGetTitle: <FormattedMessage {...messages.whatDoYouGetTitle} />,
    whatDoYouGetCopy: <FormattedMessage {...messages.whatDoYouGetCopy} />,
    popUpTitle: <FormattedMessage {...messages.whatDoYouGetPopUpTitle} />,
    popUpText: <FormattedMessage {...messages.whatDoYouGetPopUpText} />,
    whatDoYouGetCta: <FormattedMessage {...messages.whatDoYouGetCta} />,
    // stats
    statsTitle: <FormattedMessage {...messages.statsTitleV2} />,
    days: <FormattedMessage {...messages.daysString} />,
    stats1: <FormattedMessage {...messages.stats1V2} />,
    stats2: <FormattedMessage {...messages.stats2V2} />,
    stats3: <FormattedMessage {...messages.stats3V2} />,
    stats4: <FormattedMessage {...messages.stats4V2} />,
    // footnotes
    footnote1Link: <FormattedMessage {...messages.footnote1Link} />,
    footnote1: <FormattedMessage {...messages.footnote1} />,
    footnote2Link: <FormattedMessage {...messages.footnote2Link} />,
    footnote2: <FormattedMessage {...messages.footnote2} />,
  },
};

export default contentv2;
